import { getCSSVariable } from '../../../../stylesheets/cssVariablesUtils';

export const selectSx = {
    container: {
        width: '100%',
        height: '100%',
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: getCSSVariable('jungleGreen'),
            },
            '&.Mui-focused fieldset': {
                borderColor: getCSSVariable('jungleGreen'),
            },
        },
    },
    label: {
        top: '-7px',
        '&.MuiInputLabel-filled': {
            top: '0px',
        },
        '&.Mui-focused': {
            color: getCSSVariable('jungleGreen'),
            top: '0px',
        },
    },
    menuItem: {
        '&.Mui-selected': {
            backgroundColor: getCSSVariable('greenSelected'),
        },
        '&.Mui-selected:focus': {
            backgroundColor: getCSSVariable('greenSelected'),
        },
        '&.Mui-selected:hover': {
            backgroundColor: getCSSVariable('greenSelectedDark'),
        },
    },
};
